import { useGiveawaysQuery } from 'root/src/client/v2/giveaways/hooks/api/giveawaysApi';
import { GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
export function useGiveawayActive() {
    var _a, _b;
    const giveawaysQuery = useRecentGiveawaysQuery();
    const giveawayActive = (_b = (_a = giveawaysQuery === null || giveawaysQuery === void 0 ? void 0 : giveawaysQuery.data) === null || _a === void 0 ? void 0 : _a.giveaways) === null || _b === void 0 ? void 0 : _b.findLast((giveaway) => {
        return giveaway.status === GiveawayStatus.Active;
    });
    return { giveaway: giveawayActive, isLoading: giveawaysQuery.isFetching || giveawaysQuery.isLoading };
}
export function useGiveawaysResolved() {
    var _a, _b;
    const giveawaysQuery = useRecentGiveawaysQuery();
    return ((_b = (_a = giveawaysQuery === null || giveawaysQuery === void 0 ? void 0 : giveawaysQuery.data) === null || _a === void 0 ? void 0 : _a.giveaways) === null || _b === void 0 ? void 0 : _b.filter((giveaway) => {
        return giveaway.status === GiveawayStatus.Resolved;
    })) || [];
}
export function useRecentGiveawaysQuery() {
    return useGiveawaysQuery({
        payload: {
            userId: getCookie('userId'),
            limit: 2,
        },
    });
}
